import rows from './touristDestinations.json';

export const DESTINATIONS = rows;
export const PAGE_SIZE = 24;
export const ORIGIN = 'https://vvpsstaxiservices.com';
export const directoryPath = (state = '') => `/destinations/${state ? state + '/' : ''}`;
export const pagePath = (state = '', page = 1) => `${directoryPath(state)}${page > 1 ? `page/${page}/` : ''}`;
export const normalizePath = value => `${String(value).replace(/\/+$/, '')}/`;
export const STATES = [...new Set(rows.map(d => d.state))].map(name => {
  const destinations = rows.filter(d => d.state === name);
  return {name, slug:destinations[0].path.split('/')[2], destinations};
});
export const TYPES = [...new Set(rows.map(d => d.type))].sort();
export const DIRECTORY_PATHS = [pagePath(), ...Array.from({length:Math.ceil(rows.length / PAGE_SIZE) - 1}, (_, i) => pagePath('', i + 2)), ...STATES.flatMap(s => Array.from({length:Math.ceil(s.destinations.length / PAGE_SIZE)}, (_, i) => pagePath(s.slug, i + 1)))];
export const DESTINATION_PATHS = rows.map(d => d.path);
